import actions from './index';
import { BASE_URL } from '../constants/api';

export const ACTIONS = {
  INVALIDATE_ITEM: 'ITEM_RESPONSES_INVALIDATE_ITEM',
  GET_ALL: 'ITEM_RESPONSES_GET_ALL',
  GET_ALL_SUCCESS: 'ITEM_RESPONSES_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'ITEM_RESPONSES_GET_ALL_FAILURE',
};

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
    },
  });
};

export const getAll = actions.getAll(
  activityId => `${BASE_URL}/intelanalytics/activity-aggregation/${activityId}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);
